import {
  Accordion,
  Box,
  ContentTemplate,
  KeyValue,
  PAYLOAD_DATE_FORMAT,
  SectionHeader,
  Typography
} from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdminProfileResponseObject } from 'web-library/models/AccountManagementConfiguration';

import { makeStyles } from 'tss-react/mui';
import AdminPersonalParticulars from '../../../../pages/userAccountManagement/CreateEditViewAdminAccountDetails/AdminPersonalParticulars';
import AdminContactInformation from '../../../../pages/userAccountManagement/CreateEditViewAdminAccountDetails/AdminContactInformation';
import dayjs from "dayjs";


const useStyles = makeStyles()((theme) =>
({
  statusHeader: {
    marginTop: theme.spacing(-2),
    marginBottom: theme.spacing(6),
  },
  divider: {
    marginTop: theme.spacing(-4),
  },
  userGroup: {
    marginBottom: theme.spacing(2),
  },
}));

export interface AdminDetailsProps {
  adminProfileDetails: AdminProfileResponseObject;
}

const AdminDetails = ({ adminProfileDetails }: AdminDetailsProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      <ContentTemplate type="full" isContinuable>
        <SectionHeader title={t('admin->>UserAccountManagement.AccountDetails')} />
        <Accordion defaultExpanded header={t('admin->>UserAccountManagement.PersonalParticulars')}>
          {adminProfileDetails && (
            <AdminPersonalParticulars
              isEditState={false}
              adminProfileDetails={adminProfileDetails}
            />
          )}
        </Accordion>

        <Accordion
          defaultExpanded
          header={t('admin->>UserAccountManagement.ContactInformation')}
          bottomLine={false}
        >
          {adminProfileDetails && (
            <AdminContactInformation
              isEditState={false}
              adminProfileDetails={adminProfileDetails}
            />
          )}
        </Accordion>
      </ContentTemplate>

      <ContentTemplate isContinuable continuous isDividerBottom>
        <Box className={classes.divider} />
      </ContentTemplate>

      <ContentTemplate type="full" continuous isDividerBottom>
        <Typography className={classes.statusHeader} variant="h3">
          {t('admin->>UserAccountManagement.AccountDetails')}
        </Typography>

        <Box>
          <KeyValue
            keyText={t('admin->>UserAccountManagement.UserType')}
            valueText={t('admin->>AdminAccountManagement.Admin')}
          />
        </Box>

        <Box className={classes.userGroup}>
          <KeyValue
            keyText={t('admin->>AdminAccountManagement.UserGroups')}
            valueText={
              adminProfileDetails?.roles && adminProfileDetails?.roles.length !== 0
                ? adminProfileDetails?.roles.map((role) => role.displayName).join(', ')
                : '-'
            }
            capitalize={false}
          />
        </Box>
        <Box>
          <KeyValue
            keyText={t('admin->>UserAccountManagement.ExpirationDate')}
            valueText={
              adminProfileDetails.expiryDate === undefined || !adminProfileDetails.expiryDate
                ? '-'
                : dayjs(adminProfileDetails.expiryDate, PAYLOAD_DATE_FORMAT).format('DD MMM YYYY')
            }
          />
        </Box>
      </ContentTemplate>
    </>
  );
};

export default AdminDetails;
